import React from 'react';
import { Column } from 'react-table';
import { useTranslation } from 'react-i18next';
import { shouldShowMerchants } from 'Selectors';
import useReports from 'Hooks/query-hooks/reports/useReports';
import useReplaceMerchant from 'Hooks/useReplaceMerchant';
import useGetReduxUsers from 'Hooks/reduxHelperHooks/useGetReduxUsers';
import Table from './ReportsTable';

type Props = {
    reportType: ReportType;
};

const ReportsTable = ({ reportType }: Props) => {
    const { t } = useTranslation();
    const { users } = useGetReduxUsers();
    const { data: reportData, isLoading, isError } = useReports(reportType, users);
    const rawData = !isError && reportData ? reportData : [];

    const rawColumns: Column<FlatReportDataItem>[] = [
        {
            id: 'modifiedFlag',
            renderType: 'modifiedIcon',
            accessor: 'modifiedFlag',
            disableSortBy: true,
            width: 5
        },
        {
            Header: 'Report Created',
            id: '_formatted.createdAt',
            renderType: 'datetime',
            sortType: 'datetime',
            dataType: 'datetime',
            accessor: 'createdAt',
            preformattedValue: (d) => d.createdAt,
            width: 90
        },
        {
            Header: `${t('Merchant')}`,
            width: 90,
            accessor: 'merchant',
            id: 'merchant',
            dataType: 'text',
            renderType: 'overrideCell',
            Cell: (v: any) => useReplaceMerchant(v.value)
        },
        {
            Header: 'Created By',
            id: '_formatted.createdBy',
            width: 80,
            accessor: (d) => d?._formatted?.createdBy,
            dataType: 'text'
        },
        {
            Header: 'Date Range',
            width: 90,
            accessor: 'dateRangeType',
            id: 'dateRangeType',
            dataType: 'text'
        },
        {
            Header: 'Dates',
            width: 125,
            id: 'dateRangeLabel',
            accessor: (d) => d._formatted.dateRangeLabel,
            dataType: 'text'
        }
    ];

    // slice out merchant columns if shouldShowMerchants() is false
    const merchantColumnIndex = rawColumns.findIndex((object) => {
        return object.id === 'merchant';
    });
    const modifiedColumns = rawColumns.slice(0, merchantColumnIndex).concat(rawColumns.slice(merchantColumnIndex + 1));

    return (
        <Table
            rawData={rawData}
            rawColumns={shouldShowMerchants() ? rawColumns : modifiedColumns}
            isLoading={isLoading}
            reportType={reportType}
        />
    );
};

export default ReportsTable;
